import { render, staticRenderFns } from "./EventCreateDetails.vue?vue&type=template&id=4788f222&"
import script from "./EventCreateDetails.vue?vue&type=script&lang=js&"
export * from "./EventCreateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4788f222')) {
      api.createRecord('4788f222', component.options)
    } else {
      api.reload('4788f222', component.options)
    }
    module.hot.accept("./EventCreateDetails.vue?vue&type=template&id=4788f222&", function () {
      api.rerender('4788f222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/steps/EventCreateDetails.vue"
export default component.exports